import React from 'react';

export function Kwai() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#FF6A00"/>
            <circle cx="10" cy="7.5" r="2.1" fill="#FAFAFA"/>
            <circle cx="14" cy="7.5" r="2.1" fill="#FAFAFA"/>
            <rect x="6" y="9" width="12" height="10" rx="3" fill="#FAFAFA"/>
            <circle cx="12" cy="14" r="2.4" fill="#FF6A00"/>
            <circle cx="12" cy="14" r="1.2" fill="#FAFAFA"/>
        </svg>

    )
}